// extracted by mini-css-extract-plugin
module.exports = {"centerbg":"centerView_centerbg__1hZPb","center_box_img":"centerView_center_box_img__29y2U","hide":"centerView_hide__1TU9k"};